/**
 * Bookable services – shared between ServicesPage and BookingSystem.
 * Static list is fallback only; prefer loadBookableServices() from the API.
 */
import axios from 'axios';
import { API_BASE } from '../config/api';

export const BOOKABLE_SERVICES = [
  {
    id: 'phone',
    name: 'الاستشارة الهاتفية السريعة',
    description: 'جلسة مركزة وسريعة عبر الهاتف للإجابة على استفساراتك المحددة وتوجيهك للطريق الصحيح. مثالية للطالبة التي تحتاج "رأي خبير" في نقطة محددة.',
    duration: '30 دقيقة',
    price: 89,
    eveningPrice: 89,
    features: ['مخصصة للبنات فقط', 'حل فوري لمشكلة عالقة'],
  },
  {
    id: 'zoom',
    name: 'جلسات الشرح والمناقشة ',
    description: 'جلسة تفاعلية مرئية نغوص فيها في عمق بحثك. سواء كنتِ تبحثين عن عنوان، أو تريدين فهم الثغرات وكيفية تعديلها بنفسك.',
    duration: '60 دقيقة',
    morningPrice: 150,
    eveningPrice: 200,
    features: ['شرح مباشر للثغرات', 'اقتراح عناوين دراسات جديدة', 'تسجيل الجلسة متاح للمراجعة'],
    featured: true,
  },
  {
    id: 'defense',
    name: 'التدريب على المناقشة (المحاكاة)',
    description: 'بروفة حقيقية ليوم المناقشة. أقرأ الأجزاء المحورية في بحثك، وأجهز لكِ الأسئلة المتوقعة، وأمارس عليكِ "الضغط العلمي" لتكسري حاجز الخوف وتدافعي عن بحثك بثقة.',
    duration: 'ساعة مكثفة',
    price: 350,
    eveningPrice: 350,
    features: ['محاكاة أجواء المناقشة الواقعية', 'تعزيز الثقة وسرعة البديهة'],
  },
];

/**
 * Fetch active services from the API only (no static fallback).
 * Returns [] if the request fails or the list is empty.
 */
export async function fetchPublicServices() {
  try {
    const res = await axios.get(`${API_BASE}/api/services`);
    if (res.data && Array.isArray(res.data.services)) {
      return res.data.services;
    }
  } catch (err) {
    console.warn('Failed to load services from API:', err?.message);
  }
  return [];
}

/**
 * Fetch active services from the API. Falls back to BOOKABLE_SERVICES
 * if the request fails or returns an empty list (used by booking).
 */
export async function loadBookableServices() {
  const services = await fetchPublicServices();
  return services.length ? services : BOOKABLE_SERVICES;
}

/** Get service by id from a list (defaults to static catalog). Returns Zoom as default if not found. */
export function getServiceById(id, list = BOOKABLE_SERVICES) {
  const catalog = Array.isArray(list) && list.length ? list : BOOKABLE_SERVICES;
  const found = catalog.find((s) => s.id === id);
  return found || catalog.find((s) => s.id === 'zoom') || catalog[0] || BOOKABLE_SERVICES[1];
}

/** Default service when user opens /booking directly (e.g. Zoom / featured). */
export function getDefaultBookingService(list = BOOKABLE_SERVICES) {
  const catalog = Array.isArray(list) && list.length ? list : BOOKABLE_SERVICES;
  return (
    catalog.find((s) => s.id === 'zoom') ||
    catalog.find((s) => s.featured) ||
    catalog[0] ||
    BOOKABLE_SERVICES.find((s) => s.id === 'zoom')
  );
}

/** Display price text for a service card. */
export function formatServicePriceLabel(service) {
  if (!service) return '';
  const morning = service.morningPrice;
  const evening = service.eveningPrice;
  const base = service.price;

  if (
    morning != null &&
    evening != null &&
    Number(morning) !== Number(evening)
  ) {
    return `${morning} - ${evening} ريال`;
  }

  if (base != null) return `${base} ريال`;
  if (morning != null) return `${morning} ريال`;
  if (evening != null) return `${evening} ريال`;
  return '';
}
